import styled from 'styled-components';

import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';

export const FileType = styled.span`
  font-family: 'Inter';
  font-size: 14px;
  color: ${props => props.theme.colors.davysGrey};
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 16px;
  margin-top: 24px;
`; 


export const DragAndDropContainer = styled.div`
  display: flex;
  padding-bottom: 8px;
  justify-content: center;
  align-items: center;
  flex: 1 0 0;
  align-self: stretch;
  border-radius: 8px;
  border: 3px dashed ${props => props.theme.colors.celticBlue};
  background: rgba(33, 115, 255, 0.10);
  min-height: 300px;
  transition: all 0.3s ease;
  font-family: "Inter";

  &:hover {
    background: rgba(33, 115, 255, 0.15);
  }

  &.active {
    background: rgba(33, 115, 255, 0.20);
  }
`;

export const DragAndDropContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 32px;
  font-family: "Inter";

  h3 {
    font-size: 18px;
    font-weight: 500;
    color: ${props => props.theme.colors.darkCharcoal};
    margin: 0 0 8px 0;
    font-family: "Inter";
  }

  p {
    font-size: 14px;
    color: ${props => props.theme.colors.grey};
    margin: 0;
    font-family: "Inter";
  }
`;

export const FileIcon = styled(InsertDriveFileIcon)`
  font-size: 60px !important;
  color: ${props => props.theme.colors.celticBlue};
  margin-bottom: 16px;
`;

export const FileName = styled.h4`
  margin: 0 0 8px 0;
  color: ${props => props.theme.colors.darkCharcoal};
`;
